module.exports = __webpack_public_path__ + "img/bottomold2.4a531aeb.png";